/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inserting_Blank_Frames_FailedInputs */



/**
* | output |
* | --- |
* | "Inserting blank frames failed" |
*
* @param {Inserting_Blank_Frames_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const inserting_blank_frames_failed = /** @type {((inputs?: Inserting_Blank_Frames_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inserting_Blank_Frames_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l’insertion d’images vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Einfügen leerer Frames ist fehlgeschlagen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserimento di frame vuoti non riuscito")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось вставить пустые рамки.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al insertar marcos en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入空白帧失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白フレームの挿入に失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खाली फ्रेम डालने में विफलता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A inserção de quadros em branco falhou.")
	return /** @type {LocalizedString} */ ("Inserting blank frames failed")
});